/**
 * 路由门禁的唯一配置来源（侧栏菜单与路由守卫共用，避免两处口径漂移）。
 */

/**
 * 平台专属路由：这些接口走 `EnsurePlatform`，代管只读令牌（pflg=0）调用会 403。
 * 代管进行中必须整体屏蔽，而不是"菜单藏起来、敲 URL 还能进"。
 */
export const PLATFORM_ONLY_KEYS = new Set([
  '/overview',
  '/tenants',
  '/region',
  '/platform',
  '/system/screen-scan',
  '/system/screen-devices',
  '/system/app-versions',
  '/system/app-releases',
  // 以下接口同样走 EnsurePlatform：代管只读令牌进入后点保存必 403
  '/system/users',
  '/system/approval',
  '/system/org-config'
]);

/**
 * 路由级权限码（任一满足即可），取值与 `layouts/AppLayout` 的 MENU `perm` 完全一致。
 * `/overview` 对应的 `sys:platform:metric:view` 是后端 `EnsurePlatform` 的硬性要求，
 * 必须与菜单同一口径，否则菜单藏起来了、敲 URL 仍能进页面并吃到 403。
 */
export const ROUTE_PERMS: Record<string, string[]> = {
  overview: ['sys:platform:metric:view'],
  tenants: ['sys:tenant:view'],
  region: ['sys:region:manage'],
  // 机构四页共用菜单一级分组权限（与 AppLayout 的 g:org 同口径）
  'system/orgs': ['sys:org:manage'],
  'system/org-groups': ['sys:org:manage'],
  'system/org-structure': ['sys:org:manage'],
  'system/org-space': ['sys:org:manage'],
  'system/users': ['sys:user:manage'],
  'system/approval': ['sys:approval:manage'],
  platform: ['sys:platform:config'],
  'system/org-config': ['sys:config:manage'],
  'system/screen-devices': ['sys:config:manage'],
  'system/screen-scan': ['sys:config:manage'],
  'system/app-versions': ['sys:config:manage'],
  'system/app-releases': ['sys:config:manage'],
  // 后端 AuditQuery.EnsureAuditPerm 允许两个码任一（平台门户码等同放行）
  'system/audit': ['sys:audit:view', 'sys:platform:audit']
};
